import React from 'react'
import styles from './H2.module.scss'
import cl from 'classnames'
import { H2Props } from './H2.types'

const H2Component = (props: H2Props) => {
  const {
    className,
    children,
    bold,
    overflowEllipsis,
    ...rest
  } = props

  return (
    <h2
      className={cl(styles.heading2, {
        [styles.bold]: bold,
        [styles.textOverflow]: overflowEllipsis
      }, className)}
      {...rest}
    >
      {children}
    </h2>
  )
}

const H2 = H2Component
export { H2 }
